"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ApPeriodPicker = void 0;
var React = require("react");
var ApButtons_1 = require("../ApButtons");
var ApIcon_1 = require("../ApIcon");
var ApMenu_1 = require("../ApMenu");
var styles_1 = require("./styles");
var MONTHS = [
    'Jan',
    'Feb',
    'Mar',
    'Apr',
    'May',
    'Jun',
    'Jul',
    'Aug',
    'Sep',
    'Oct',
    'Nov',
    'Dec',
];
var getCurrentPeriod = function () {
    var date = new Date();
    var month = date.getMonth() + 1;
    var quarter = Math.ceil(month / 3);
    var year = date.getFullYear();
    return { quarter: quarter, month: month, year: year };
};
var getPeriodName = function (index) { return "P" + index; };
var getQuarterName = function (index) { return "Q" + index; };
var ApPeriodPicker = /** @class */ (function (_super) {
    __extends(ApPeriodPicker, _super);
    function ApPeriodPicker() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            isMenuOpen: false,
            year: _this.props.data.year || getCurrentPeriod().year,
        };
        _this.toggleMenu = function (isOpen) {
            var data = _this.props.data;
            _this.setState({ isMenuOpen: isOpen });
            if (!isOpen && data.year) {
                _this.setState({
                    year: data.year,
                });
            }
        };
        _this.setNextYear = function () {
            var year = _this.state.year;
            _this.setState({ year: year + 1 });
        };
        _this.setPrevYear = function () {
            var year = _this.state.year;
            _this.setState({ year: year - 1 });
        };
        _this.selectPeriod = function (period) {
            var onChange = _this.props.onChange;
            var year = _this.state.year;
            onChange({ year: year, period: period });
            _this.toggleMenu(false);
        };
        return _this;
    }
    ApPeriodPicker.prototype.componentDidUpdate = function (prevProps) {
        var data = this.props.data;
        if (data.year && data.year !== prevProps.data.year) {
            this.setState({
                year: data.year,
            });
        }
    };
    ApPeriodPicker.prototype.render = function () {
        var _this = this;
        var _a = this.props, className = _a.className, enableBeforeToday = _a.enableBeforeToday, data = _a.data, disabled = _a.disabled, showPeriod = _a.showPeriod, isQuarter = _a.isQuarter, onChange = _a.onChange;
        var _b = this.state, year = _b.year, isMenuOpen = _b.isMenuOpen;
        var _c = getCurrentPeriod(), todayMonth = _c.month, todayYear = _c.year, todayQuarter = _c.quarter;
        var selectedPeriod = data.period, selectedYear = data.year;
        var selectedValue = selectedYear && selectedPeriod
            ? isQuarter
                ? getQuarterName(selectedPeriod) + "/" + selectedYear
                : showPeriod
                    ? getPeriodName(selectedPeriod) + "/" + selectedYear
                    : MONTHS[selectedPeriod - 1] + " " + selectedYear
            : '';
        return (React.createElement(ApMenu_1.ApMenu, { isOpen: isMenuOpen, toggleMenu: this.toggleMenu, className: className, button: React.createElement("div", { style: disabled ? { pointerEvents: 'none' } : {} },
                React.createElement(styles_1.Wrapper, null,
                    React.createElement(styles_1.StyledTextInput, __assign({ placeholder: "date", value: selectedValue, onChange: function () { return null; }, disabled: disabled }, { readOnly: true })),
                    React.createElement(styles_1.InnerIcon, null,
                        React.createElement(ApIcon_1.ApIcon, { iconName: "baseline_calendar_today", iconSize: 20 })))) },
            React.createElement(styles_1.MenuContent, null,
                React.createElement(styles_1.PickerHeader, null,
                    React.createElement(ApButtons_1.ApButtonIcon, { iconName: "baseline_keyboard_arrow_left", disabled: !enableBeforeToday && year <= todayYear, onClick: this.setPrevYear }),
                    React.createElement(styles_1.PickerYear, null, year),
                    React.createElement(ApButtons_1.ApButtonIcon, { iconName: "baseline_keyboard_arrow_right", onClick: this.setNextYear })),
                React.createElement(styles_1.PickerContent, { isQuarter: isQuarter },
                    React.createElement(styles_1.PickerGrid, null, !isQuarter
                        ? MONTHS.map(function (name, index) {
                            var isDisabled = !enableBeforeToday &&
                                (year < todayYear ||
                                    (year === todayYear && index + 1 < todayMonth));
                            var isActive = year === selectedYear && index + 1 === selectedPeriod;
                            return (React.createElement(styles_1.PickerPeriod, { key: index, disabled: isDisabled, active: isActive, onClick: !isDisabled
                                    ? function () {
                                        _this.selectPeriod(index + 1);
                                    }
                                    : undefined }, !showPeriod ? name : getPeriodName(index + 1)));
                        })
                        : __spread(Array(4).keys()).map(function (key) {
                            var isDisabled = !enableBeforeToday &&
                                (year < todayYear ||
                                    (year === todayYear && key + 1 < todayQuarter));
                            var isActive = year === selectedYear && key + 1 === selectedPeriod;
                            return (React.createElement(styles_1.PickerPeriod, { key: key, disabled: isDisabled, active: isActive, onClick: !isDisabled
                                    ? function () {
                                        onChange({ year: year, period: key + 1 });
                                        _this.toggleMenu(false);
                                    }
                                    : undefined }, getQuarterName(key + 1)));
                        }))))));
    };
    ApPeriodPicker.defaultProps = {
        data: {},
        disabled: false,
        enableBeforeToday: false,
        isQuarter: false,
        showPeriod: false,
    };
    return ApPeriodPicker;
}(React.Component));
exports.ApPeriodPicker = ApPeriodPicker;
//# sourceMappingURL=ApPeriodPicker.js.map